import React, {useState} from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { validateForgotPassword } from '../../Services/loadOrder';
import toast from 'react-hot-toast';

const ForgotMailModal = ({ open, onClose, pharmacyID, userID, mailTo }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);


  const handleConfirm = async () => {
    setLoading(true);
    try {
      const response = await validateForgotPassword(userID, "", pharmacyID, "Confirmation");
      if (response) {
        toast.success('Password reset link sent to your email.');
        setTimeout(() => {
          navigate('/change-password');
        }, 1000); // short delay for UX
      } else {
        toast.error('Failed to send password reset link.');
        setLoading(false);
      }
    } catch (error) {
      console.error('Error validating password reset:', error);
      toast.error('Something went wrong.');
      setLoading(false);
    }
  };


  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Success</DialogTitle>
      <DialogContent>
        <Typography variant="subtitle1">
          Your Reset Password will be sent to {mailTo} 
       </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          sx={{
            backgroundColor: '#f0f0f0',
            color: '#333',
            '&:hover': {
              backgroundColor: '#e0e0e0',
            },
          }}>Cancel</Button>
        <Button
          onClick={handleConfirm}
          sx={{
            backgroundColor: '#ec008c',
            color: 'white',
            '&:hover': {
              backgroundColor: '#d5006d',
            },
          }}
        >
          OK
        </Button>
      </DialogActions>
      {loading && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          background: 'rgba(255,255,255,0.7)',
          zIndex: 3000,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <div style={{
            border: '6px solid #f3f3f3',
            borderTop: '6px solid #EC088C',
            borderRadius: '50%',
            width: 48,
            height: 48,
            animation: 'spin 1s linear infinite'
          }} />
          <div style={{marginTop: 24, fontSize: '1.2rem', fontWeight: 500, color: '#222'}}>Processing...</div>
          <style>{`@keyframes spin { 0% { transform: rotate(0deg);} 100% {transform: rotate(360deg);} }`}</style>
        </div>
      )}
    </Dialog>
  );
};

export default ForgotMailModal;

